import { Injectable } from '@angular/core';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import {
	fnCallable,
	GetRedirectUrlRequest,
	GetRedirectUrlResponse,
	RedirectUrlContext,
	GetDocumentRequest,
	FCTSendDataRequest,
	FCTSendDataResponse,
	GetDocumentResponse,
	FCTgetStatusResponse,
	FCTgetStatusRequest,
} from '@fnModels/fct';
import { BusinessUserRole } from '@models/businesses';
import { FCTDocumentType } from '@models/title-insurance';
import { FCTSendData } from '@models/title-insurance/fct';
import { UserProfile } from '@models/userProfile';
import { Store } from '@ngxs/store';
import { BusinessUsersState } from '@state/business-users/business-users.state';
import { UserProfileState } from '@state/user-profile';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class FCTFunctions {
	constructor(
		private fns: AngularFireFunctions,
		private store: Store,
	) {}

	getDocument = (
		orderId: string,
		lawyerId: string,
		documentName: FCTDocumentType,
	): Observable<GetDocumentResponse> => {
		const callable = this.fns.httpsCallable(fnCallable.getDocument);
		const data: GetDocumentRequest = {
			orderId,
			documentName,
			lawyerId,
			userEmail: this.profile.email,
			userFirstName: this.profile.firstName,
			userLastName: this.profile.lastName,
			userRole: this.userRole,
		};

		return callable(data);
	};

	sendData = (
		lawyerId: string,
		data: FCTSendData,
	): Observable<FCTSendDataResponse> => {
		const callable = this.fns.httpsCallable(fnCallable.pushData);

		const request: FCTSendDataRequest = {
			lawyerId,
			userEmail: this.profile.email,
			userFirstName: this.profile.firstName,
			userLastName: this.profile.lastName,
			userRole: this.userRole,
			data,
		};

		return callable(request);
	};

	getRedirectUrl = (
		lawyerId: string,
		urlType: RedirectUrlContext,
		dealURN?: string,
	): Observable<GetRedirectUrlResponse> => {
		const callable = this.fns.httpsCallable(fnCallable.getRedirectUrl);
		const data: GetRedirectUrlRequest = {
			lawyerId,
			urlType,
			dealURN,
			userEmail: this.profile.email,
			userFirstName: this.profile.firstName,
			userLastName: this.profile.lastName,
			userRole: this.userRole,
		};

		return callable(data);
	};

	getStatus = (
		lawyerId: string,
		dealURN: string,
	): Observable<FCTgetStatusResponse> => {
		const callable = this.fns.httpsCallable(fnCallable.getStatus);
		const data: FCTgetStatusRequest = {
			lawyerId,
			dealURN,
			userEmail: this.profile.email,
			userFirstName: this.profile.firstName,
			userLastName: this.profile.lastName,
			userRole: this.userRole,
		};

		return callable(data);
	};

	private get profile(): UserProfile {
		return this.store.selectSnapshot(UserProfileState.getProfile);
	}

	private get userRole(): BusinessUserRole {
		return this.store.selectSnapshot(BusinessUsersState.getLoggedInUserRole);
	}
}
